/*!
 * ETAR theme v4.2.4 — Product page "The bottle room"
 * Developed by FACTICIED · https://www.facticied.com
 * Gallery with a tilting bottle on a plinth, variant logic, sticky Add to bag bar and add to bag
 * (the photo flies into the bag through EtarCart.fly).
 */
(() => {
  if (customElements.get('et-product')) return;
  const mqMobile = window.matchMedia('(max-width: 749px)');
  const mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fmt = (format, cents) => {
    const v = cents / 100;
    const g = (d, t, sp) => { const p = v.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? sp + p[1] : ''); };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? g(0, ',', '.') : k === 'amount_with_comma_separator' ? g(2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? g(0, '.', ',') : g(2, ',', '.'));
  };

  class EtProduct extends HTMLElement {
    connectedCallback() {
      if (this._on) return; this._on = true;
      this.ac = new AbortController();
      const opt = { signal: this.ac.signal };
      const money = (c) => fmt(this.dataset.money, c);
      this.money = money;
      try { this.product = JSON.parse(this.querySelector('[data-product-json]').textContent); } catch (e) { this.product = null; }
      this.viewer = this.querySelector('[data-viewer]');
      this.slidesWrap = this.querySelector('[data-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.bar = this.querySelector('[data-bar]');
      this.count = this.querySelector('[data-count]');
      this.form = this.querySelector('[data-product-form]') || this.querySelector('form.et-pp__form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.toast = this.querySelector('[data-toast]');
      this.idx = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-on')));
      this.mark(this.idx, true);
      if (mqMobile.matches && this.idx > 0) requestAnimationFrame(() => { this.slidesWrap.scrollLeft = this.idx * this.slidesWrap.clientWidth; });

      // Tilt toward the pointer
      if (this.classList.contains('et-pp--tilt') && mqFine.matches && !mqReduce.matches) {
        this.viewer.addEventListener('pointermove', (e) => {
          if (this.viewer.classList.contains('is-zoom')) return;
          const r = this.viewer.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          this.viewer.style.setProperty('--ty', (x * 12).toFixed(2) + 'deg');
          this.viewer.style.setProperty('--tx', (y * -8).toFixed(2) + 'deg');
        }, opt);
        this.viewer.addEventListener('pointerleave', () => { this.viewer.style.setProperty('--ty', '0deg'); this.viewer.style.setProperty('--tx', '0deg'); }, opt);
      }

      // Slim Add to bag bar
      this.sticky = this.querySelector('[data-sticky]');
      const buy = this.querySelector('[data-buy]');
      if (this.sticky && buy) {
        this.sio = new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          this.sticky.classList.toggle('is-on', past);
          this.sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          this.sticky.querySelector('[data-sticky-add]').tabIndex = past ? 0 : -1;
        });
        this.sio.observe(buy);
        this.sticky.querySelector('[data-sticky-add]').addEventListener('click', (e) => this.add(e.currentTarget), opt);
      }

      // Gallery
      this.thumbs.forEach((t) => t.addEventListener('click', (e) => this.show(this.indexOf(t.dataset.thumb), e), opt));
      this.querySelector('[data-gal-prev]')?.addEventListener('click', (e) => this.show(this.idx - 1, e), opt);
      this.querySelector('[data-gal-next]')?.addEventListener('click', (e) => this.show(this.idx + 1, e), opt);
      this.slidesWrap?.addEventListener('scroll', () => {
        if (!mqMobile.matches) return;
        const i = Math.round(this.slidesWrap.scrollLeft / this.slidesWrap.clientWidth);
        this.mark(i);
      }, { passive: true, signal: this.ac.signal });

      // Zoom (desktop)
      if (this.classList.contains('et-pp--zoom') && mqFine.matches) {
        this.viewer.addEventListener('click', (e) => {
          if (e.target.closest('button')) return;
          const s = this.slides[this.idx];
          if (!s || s.dataset.type !== 'image') return;
          this.viewer.classList.toggle('is-zoom');
          this.zoomAt(e);
        }, opt);
        this.viewer.addEventListener('pointermove', (e) => { if (this.viewer.classList.contains('is-zoom')) this.zoomAt(e); }, opt);
        this.viewer.addEventListener('pointerleave', () => this.viewer.classList.remove('is-zoom'), opt);
      }

      // Options
      this.querySelectorAll('[data-value]').forEach((r) => r.addEventListener('change', () => this.onOption(), opt));
      this.updateAvailability();

      // Quantity
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
        const q = this.querySelector('input[name="quantity"]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      }, opt));

      // Add to bag
      this.form?.addEventListener('submit', (e) => { e.preventDefault(); this.add(); }, opt);

      // Size guide
      this.querySelectorAll('[data-sg-open]').forEach((b) => b.addEventListener('click', () => {
        const d = this.querySelector(`[data-sg="${b.dataset.sgOpen}"]`);
        if (d && d.showModal) d.showModal();
      }, opt));
      this.querySelectorAll('[data-sg-close]').forEach((b) => b.addEventListener('click', () => b.closest('dialog').close(), opt));
      this.querySelectorAll('dialog[data-sg]').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }, opt));

      // Copy link
      this.querySelector('[data-copy]')?.addEventListener('click', async (e) => {
        const b = e.currentTarget;
        try { await navigator.clipboard.writeText(b.dataset.copy); this.say(b.dataset.copied || 'Copied'); } catch (err) { /* ignore */ }
      }, opt);

      // Theme editor: open the size guide when its block is selected
      document.addEventListener('shopify:block:select', (e) => { if (e.target.matches && e.target.matches('dialog[data-sg]') && this.contains(e.target)) e.target.showModal?.(); }, opt);
      document.addEventListener('shopify:block:deselect', (e) => { if (e.target.matches && e.target.matches('dialog[data-sg]')) e.target.close?.(); }, opt);
    }

    disconnectedCallback() { this.ac.abort(); this.sio?.disconnect(); clearTimeout(this.toastT); }

    indexOf(id) { return this.slides.findIndex((s) => s.dataset.mediaId === String(id)); }

    zoomAt(e) {
      const r = this.viewer.getBoundingClientRect();
      this.viewer.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      this.viewer.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }

    show(i) {
      const n = this.slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      if (mqMobile.matches) {
        this.slidesWrap.scrollTo({ left: i * this.slidesWrap.clientWidth, behavior: mqReduce.matches ? 'auto' : 'smooth' });
        this.mark(i);
        return;
      }
      if (i === this.idx) return;
      const prev = this.slides[this.idx], next = this.slides[i];
      this.viewer.classList.remove('is-zoom');
      prev.classList.remove('is-on', 'is-rise');
      prev.querySelector('video')?.pause();
      next.classList.remove('is-rise'); void next.offsetWidth;
      next.classList.add('is-on', 'is-rise');
      this.mark(i);
    }

    mark(i, first) {
      if (!first && i === this.idx && this._marked) return;
      this._marked = true;
      this.idx = i;
      this.thumbs.forEach((t, n) => t.classList.toggle('is-on', n === i));
      this.slides.forEach((s, n) => { const img = s.querySelector('img'); if (img) img.toggleAttribute('data-fly-img', n === i); });
      if (this.bar) this.bar.style.setProperty('--i', i);
      if (this.count) this.count.textContent = i + 1;
      if (!first) this.thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    selected() {
      return Array.from(this.querySelectorAll('[data-option]')).map((fs) => {
        const c = fs.querySelector('[data-value]:checked');
        return c ? c.value : null;
      });
    }

    onOption() {
      if (!this.product) return;
      const sel = this.selected();
      this.querySelectorAll('[data-option]').forEach((fs, i) => { const b = fs.querySelector('[data-chosen]'); if (b) b.textContent = sel[i] || ''; });
      const v = this.product.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      this.variant = v;
      this.updateAvailability();
      const btn = this.querySelector('[data-add]'), txt = this.querySelector('[data-add-text]');
      const sb = this.querySelector('[data-sticky-add]'), sl = this.querySelector('[data-sticky-label]');
      if (sb) { sb.disabled = !v || !v.available; sl.textContent = !v ? this.dataset.unavailable : v.available ? this.dataset.addLabel : this.dataset.sold; }
      if (v) {
        const sp = this.querySelector('[data-sticky-price]'), sv = this.querySelector('[data-sticky-variant]');
        if (sp) sp.textContent = this.money(v.price);
        if (sv) sv.textContent = this.product.variants.length > 1 ? v.title + ' · ' : '';
        const si = this.querySelector('[data-sticky-img]');
        if (si && v.featured_image) { si.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=160'; si.removeAttribute('srcset'); }
      }
      if (!v) {
        btn.disabled = true; txt.textContent = this.dataset.unavailable;
        this.setStock('out', this.dataset.unavailable);
        return;
      }
      this.idInput.value = v.id;
      btn.disabled = !v.available;
      txt.textContent = v.available ? this.dataset.addLabel : this.dataset.sold;
      // Price
      const now = this.querySelector('[data-now]'), was = this.querySelector('[data-was]'), off = this.querySelector('[data-off]');
      now.textContent = this.money(v.price);
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      now.classList.toggle('is-sale', !!sale);
      was.hidden = !sale; if (sale) was.textContent = this.money(v.compare_at_price);
      off.hidden = !sale; if (sale) off.textContent = '-' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
      // Stock
      const low = parseInt(this.dataset.low, 10) || 0;
      if (!v.available) this.setStock('out', this.dataset.sold);
      else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= low) this.setStock('low', this.dataset.lowText.replace('%n', v.inventory_quantity));
      else this.setStock('in', this.dataset.inStock);
      // Photo of the variant
      if (v.featured_media) { const i = this.indexOf(v.featured_media.id); if (i > -1) this.show(i); }
      const flag = this.querySelector('[data-flag]');
      if (flag) { flag.hidden = !sale; if (sale) flag.textContent = '-' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%'; }
      // Address bar + WhatsApp link
      try { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) { /* ignore */ }
      const wa = this.querySelector('[data-wa-link]');
      if (wa && this.dataset.wa) {
        const msg = `${this.dataset.waText} (${v.title}) ${window.location.origin}${this.dataset.url}?variant=${v.id}`;
        wa.href = `https://wa.me/${this.dataset.wa}?text=${encodeURIComponent(msg)}`;
      }
      this.dispatchEvent(new CustomEvent('et:variant:change', { bubbles: true, detail: v }));
    }

    setStock(kind, text) {
      const el = this.querySelector('[data-stock]');
      if (!el) return;
      el.innerHTML = `<span class="is-${kind}"></span>`;
      el.firstChild.textContent = text;
    }

    // Grey out values that cannot be bought with the other choices
    updateAvailability() {
      if (!this.product || this.product.variants.length < 2) return;
      const sel = this.selected();
      this.querySelectorAll('[data-option]').forEach((fs, oi) => {
        fs.querySelectorAll('[data-value]').forEach((input) => {
          const ok = this.product.variants.some((v) => v.available && v.options[oi] === input.value && v.options.every((o, k) => k === oi || !sel[k] || o === sel[k]));
          input.closest('.et-pp__val').classList.toggle('is-na', !ok);
        });
      });
    }

    async add(from) {
      const main = this.querySelector('[data-add]');
      const btn = from || main;
      if (main.disabled) return;
      btn.classList.add('is-loading');
      const R = window.EtarRoutes || {};
      try {
        const res = await fetch((R.cartAdd || '/cart/add').replace(/\.js$/, '') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || res.status); }
        const sample = this.querySelector('[data-sample]');
        if (sample && sample.checked) await fetch((R.cartAdd || '/cart/add').replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +sample.dataset.sample, quantity: 1 }] }) }).catch(() => {});
        const cart = await (await fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('et:cart:updated', { detail: cart }));
        if (!(window.EtarCart && window.EtarCart.afterAdd(cart, btn))) this.say(this.dataset.added, true);
      } catch (err) {
        this.say(typeof err.message === 'string' && err.message.length > 3 ? err.message : this.dataset.error);
      } finally { btn.classList.remove('is-loading'); }
    }

    say(msg, link) {
      if (!this.toast) return;
      this.toast.innerHTML = '';
      const sp = document.createElement('span'); sp.textContent = msg; this.toast.appendChild(sp);
      if (link) { const a = document.createElement('a'); a.href = (window.EtarRoutes && window.EtarRoutes.cart) || '/cart'; a.textContent = this.dataset.viewBag; this.toast.appendChild(a); }
      this.toast.hidden = false;
      requestAnimationFrame(() => this.toast.classList.add('is-on'));
      clearTimeout(this.toastT);
      this.toastT = setTimeout(() => { this.toast.classList.remove('is-on'); setTimeout(() => { this.toast.hidden = true; }, 450); }, 3200);
    }
  }
  customElements.define('et-product', EtProduct);
})();
